export default __webpack_public_path__ + "static/media/circle.29ae9e2c.svg";